// [WP-F1 2026-08-02] Pure DB1 promotion guard. Blank/non-informative correction
// records remain brain-eligible, but may not enter the exact-match master DB.
import { isBlankCorrection } from "./pipeline/classify-det.js";

export const DB1_MASTER_KEY = "warranty-ca-feedback-db-v3";

export function partitionPromotion(masterKey, entries = []) {
  if (masterKey !== DB1_MASTER_KEY) return { masterEntries: entries, brainOnlyEntries: [] };
  const masterEntries = [];
  const brainOnlyEntries = [];
  for (const entry of entries) {
    (isBlankCorrection(entry?.correction) ? brainOnlyEntries : masterEntries).push(entry);
  }
  return { masterEntries, brainOnlyEntries };
}

export const brainOnlyNote = (count) => count > 0
  ? ` — ${count} blank-correction entr${count === 1 ? "y" : "ies"} → brain only`
  : "";
